import { BillingTreatment, UpgradeLicenseValue } from './upgrade-license.value';

type BillingTreatmentDto = 'pro_rata_remaining_term' | 'full_price_immediately' | 'no_charge_until_renewal';

const BILLING_TREATMENT_MAP: Record<BillingTreatment, BillingTreatmentDto> = {
    proRataRemainingTerm: 'pro_rata_remaining_term',
    fullPriceImmediately: 'full_price_immediately',
    noChargeUntilRenewal: 'no_charge_until_renewal',
};

export class UpgradeLicenseValueDto {
    pricingTierId: string;
    billingTreatment: BillingTreatmentDto;

    constructor(data: UpgradeLicenseValue) {
        this.pricingTierId = data.pricingTierId;
        this.billingTreatment = BILLING_TREATMENT_MAP[data.billingTreatment];
    }
}
